// extracted by mini-css-extract-plugin
module.exports = {"mediaContainer":"_12sp7","heading":"_1c1uR","subHeading":"_2xwCr"};